import { Component, OnInit } from '@angular/core';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import { CookieService } from 'ngx-cookie-service';
import { JournalDTO, ManageJournalDTO } from '../Models/Journal.model';
import { Globals } from '../Models/UserProfile.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import swal from 'sweetalert2';
import PerfectScrollbar from 'perfect-scrollbar';
import { SurgeonDTO, SurgeonSpecialityDTO } from '../Models/Surgeon.model';
import { ProfessionalLearningDTO } from '../Models/ProfessionalLearning.model';
import {environment} from '../../environments/environment';
import {DatePipe} from '@angular/common';
@Component({
  selector: 'app-professional-training',
  templateUrl: './professional-training.component.html',
  styleUrls: ['./professional-training.component.scss'],
  providers: [SrubUpService]

})
export class ProfessionalTrainingComponent implements OnInit {
  isImpersonateMode: boolean;
  public baseurl: string = environment.base_url;
  providers: Array<string>;

  loginUserId: number;
  public loading = false;
  invisible: number;
  editvisi: number;
  showEditingDiv: number;
  showReadOnlyDiv: number;
  iValue: number;
  index: boolean;
  edit: boolean;

  pLAList: Array<ProfessionalLearningDTO>;

  profLearningActivity: ProfessionalLearningDTO;

  pLAId: string;
  providerDetails: string;
  activityAndPresenters: string;
  topicsDescription: string;
  reflectivePractice: string;
  evidenceDescription: string;
  cPDNumber: string;
  startdate: string;
  starttime: string;
  start: string;

  imagePath: string;
  uploadUrl: string;
  imageUploadApiUrlLength: number;
  myHeaders: { [name: string]: any };
  tempUrl: Array<string>;
  imageToShow: string;

  constructor( public datepipe: DatePipe,private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.index = true;
    this.invisible = 0;
    this.editvisi = 0;

    this.showEditingDiv = -1;
    this.showReadOnlyDiv = -1;

    this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;
    this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
    this.myHeaders = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Professional Training"
    };
    this.tempUrl = new Array<string>();

    this.providers = ['Seminar', 'Course', 'Conference', 'In-Service', 'Mandatory Training', 'Workshop', 'Forum', 'Tertiary Education', 'Symposia', 'Self Directed Learning', 'Other'];

  }

  ShowImage(index) {
    this.imageToShow = this.pLAList[index].ImageBase64;
  }

  OnUploadFinished(response: any) {
    if (response.serverResponse.response.status == "200") {
      this.imagePath = response.serverResponse.response._body;
      this.imagePath = this.imagePath.substring(1, this.imagePath.length - 1);
    }
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
        this.pLAList.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });

    });
  }


  Timezone =
    [
      { value: '00:00:00', viewValue: '00:00' },
      { value: '00:30:00', viewValue: '00:30' },
      { value: '01:00:00', viewValue: '01:00' },
      { value: '01:30:00', viewValue: '01:30' },
      { value: '02:00:00', viewValue: '02:00' },
      { value: '02:30:00', viewValue: '02:30' },
      { value: '03:00:00', viewValue: '03:00' },
      { value: '03:30:00', viewValue: '03:30' },
      { value: '04:00:00', viewValue: '04:00' },
      { value: '04:30:00', viewValue: '04:30' },
      { value: '05:00:00', viewValue: '05:00' },
      { value: '05:30:00', viewValue: '05:30' },
      { value: '06:00:00', viewValue: '06:00' },
      { value: '06:30:00', viewValue: '06:30' },
      { value: '07:00:00', viewValue: '07:00' },
      { value: '07:30:00', viewValue: '07:30' },
      { value: '08:00:00', viewValue: '08:00' },
      { value: '08:30:00', viewValue: '08:30' },
      { value: '09:00:00', viewValue: '09:00' },
      { value: '09:30:00', viewValue: '09:30' },
      { value: '10:00:00', viewValue: '10:00' },
      { value: '10:30:00', viewValue: '10:30' },
      { value: '11:00:00', viewValue: '11:00' },
      { value: '11:30:00', viewValue: '11:30' },
      { value: '12:00:00', viewValue: '12:00' },
      { value: '12:30:00', viewValue: '12:30' },
      { value: '13:00:00', viewValue: '13:00' },
      { value: '13:30:00', viewValue: '13:30' },
      { value: '14:00:00', viewValue: '14:00' },
      { value: '14:30:00', viewValue: '14:30' },
      { value: '15:00:00', viewValue: '15:00' },
      { value: '15:30:00', viewValue: '15:30' },
      { value: '16:00:00', viewValue: '16:00' },
      { value: '16:30:00', viewValue: '16:30' },
      { value: '17:00:00', viewValue: '17:00' },
      { value: '17:30:00', viewValue: '17:30' },
      { value: '18:00:00', viewValue: '18:00' },
      { value: '18:30:00', viewValue: '18:30' },
      { value: '19:00:00', viewValue: '19:00' },
      { value: '19:30:00', viewValue: '19:30' },
      { value: '20:00:00', viewValue: '20:00' },
      { value: '21:00:00', viewValue: '21:00' },
      { value: '21:30:00', viewValue: '21:30' },
      { value: '22:00:00', viewValue: '22:00' },
      { value: '22:30:00', viewValue: '22:30' },
      { value: '23:00:00', viewValue: '23:00' },
      { value: '23:30:00', viewValue: '23:30' }
    ];

  Collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }

  UserClick(btnCount) {
    this.edit = false;
    this.pLAId = "";
    this.providerDetails = "";
    this.activityAndPresenters = "";
    this.topicsDescription = "";
    this.reflectivePractice = "";
    this.evidenceDescription = "";
    this.cPDNumber = "";
    this.startdate = "";
    this.starttime = "";
    this.start = "";

    if (btnCount == 1) {
      this.edit = true;
      this.showEditingDiv = -1;
      this.showReadOnlyDiv = -1;
    }
    if (btnCount == 3) {
      this.edit = false;
      this.invisible = 0;
      this.showEditingDiv = -1;
    }
  }

  getPLAList() {
    this.loading = true;
    this.scrubUpService.GetPLAs(this.token, this.loginUserId).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.pLAList = x['Data'];
       // console.log( this.pLAList);
        // this.pLAList.forEach(element => {
        //   //element.ImagePath =this.token.webAPIURL+"Speciality/GetUploadedImage?imageName="+element.ImagePath;
        //   this.tempUrl.push(element.ImagePath);
        // });
        // this.GetImage(this.tempUrl);
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  formatDateTime(dt, time) {
    var date = new Date(dt);
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();

    var mmChars = mm.split('');
    var ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]) + "T" + time;

  }

  AddPLA() {
    this.start = this.formatDateTime(this.startdate, this.starttime);

    let pla: ProfessionalLearningDTO;
    pla = new ProfessionalLearningDTO();
    pla.PLAId = "";
    pla.ActivityDetails = this.activityAndPresenters;
    pla.ImagePath = this.imagePath;
    pla.EvidenceDescription = this.evidenceDescription;
    pla.Provider = this.providerDetails;
    pla.ReflectivePractice = this.reflectivePractice;
    pla.TopicDescription = this.topicsDescription;
    pla.CPD = this.cPDNumber;
    pla.StartDate = this.startdate;
    pla.StartTime = this.starttime;
    pla.Start = this.start;

    //manipulate the start and end date as per the calendar requirement

    this.loading = true;
    this.scrubUpService.AddPLA(this.token, pla, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'PLA Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        });
        // this.specialityName = "";
        this.UserClick(3);
        this.getPLAList();
      }
      else if (x == "exists") {
        swal({
          title: 'PLA with this title already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        });
      }
      else {

      }
      this.loading = false;
    });
  }

  CollapseSurgeon(data:any,index: number) {

    this.showEditingDiv = -1;
    //this.specialityId = 0;
    //this.selectedProcedures = [];
    this.editvisi = 1;
    // this.correctiveActionUpdateExists=false;
    if (this.showReadOnlyDiv != -1) {
      if (this.iValue == index) {
        this.showReadOnlyDiv = -1;
      }
      else {
        this.showReadOnlyDiv = -1;
        this.showReadOnlyDiv = index;
        this.iValue = index;
      }
      this.activityAndPresenters = data.ActivityDetails;
      this.imagePath = data.ImagePath;
      this.evidenceDescription = data.EvidenceDescription;
      this.providerDetails = data.Provider;
      this.reflectivePractice = data.ReflectivePractice;
      this.topicsDescription = data.TopicDescription;
      this.cPDNumber = data.CPD;
      this.startdate = data.StartDate;
      var starttime=this.datepipe.transform(data.StartDate, 'hh:mm:ss a');
    // var starttime =data.StartDate.split('T')[1].split(':').slice(0,2).join(':');
      this.starttime = starttime;
      // this.activityAndPresenters = this.pLAList[index].ActivityDetails;
      // this.imagePath = this.pLAList[index].ImagePath;
      // this.evidenceDescription = this.pLAList[index].EvidenceDescription;
      // this.providerDetails = this.pLAList[index].Provider;
      // this.reflectivePractice = this.pLAList[index].ReflectivePractice;
      // this.topicsDescription = this.pLAList[index].TopicDescription;
      // this.cPDNumber = this.pLAList[index].CPD;
      // this.startdate = this.pLAList[index].StartDate;
      // this.starttime = this.pLAList[index].StartTime;
      this.edit = false;
    }
    else {
      this.activityAndPresenters = data.ActivityDetails;
      this.imagePath = data.ImagePath;
      this.evidenceDescription = data.EvidenceDescription;
      this.providerDetails = data.Provider;
      this.reflectivePractice = data.ReflectivePractice;
      this.topicsDescription = data.TopicDescription;
      this.cPDNumber = data.CPD;
      this.startdate = data.StartDate;
      var starttime=this.datepipe.transform(data.StartDate, 'hh:mm:ss a');

     // var starttime =data.StartDate.split('T')[1].split(':').slice(0,2).join(':');
      this.starttime = starttime;
      //this.starttime = data.StartTime;
      // this.activityAndPresenters = this.pLAList[index].ActivityDetails;
      // this.imagePath = this.pLAList[index].ImagePath;
      // this.evidenceDescription = this.pLAList[index].EvidenceDescription;
      // this.providerDetails = this.pLAList[index].Provider;
      // this.reflectivePractice = this.pLAList[index].ReflectivePractice;
      // this.topicsDescription = this.pLAList[index].TopicDescription;
      // this.cPDNumber = this.pLAList[index].CPD;
      // this.startdate = this.pLAList[index].StartDate;
      // this.starttime = this.pLAList[index].StartTime;
      this.showReadOnlyDiv = index;
      this.iValue = index;
      this.edit = false;
    }
  }

  EditPLA(index: number) {
    this.showReadOnlyDiv = -1;
    // this.specialityId = 0;
    // this.selectedProcedures = [];
    this.editvisi = 1;
    // this.correctiveActionUpdateExists=false;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.pLAId = this.pLAList[index].PLAId;
      this.activityAndPresenters = this.pLAList[index].ActivityDetails;
      this.imagePath = this.pLAList[index].ImagePath;
      this.evidenceDescription = this.pLAList[index].EvidenceDescription;
      this.providerDetails = this.pLAList[index].Provider;
      this.reflectivePractice = this.pLAList[index].ReflectivePractice;
      this.topicsDescription = this.pLAList[index].TopicDescription;
      this.cPDNumber = this.pLAList[index].CPD;
      this.startdate = this.pLAList[index].StartDate;
      this.starttime = this.pLAList[index].StartTime;
      this.start = this.pLAList[index].Start;

      this.edit = false;
    }
    else {
      this.pLAId = this.pLAList[index].PLAId;
      this.activityAndPresenters = this.pLAList[index].ActivityDetails;
      this.imagePath = this.pLAList[index].ImagePath;
      this.evidenceDescription = this.pLAList[index].EvidenceDescription;
      this.providerDetails = this.pLAList[index].Provider;
      this.reflectivePractice = this.pLAList[index].ReflectivePractice;
      this.topicsDescription = this.pLAList[index].TopicDescription;
      this.cPDNumber = this.pLAList[index].CPD;
      this.startdate = this.pLAList[index].StartDate;
      this.starttime = this.pLAList[index].StartTime;
      this.start = this.pLAList[index].Start;

      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }
  }

  UpdatePLA(index) {
    this.start = this.formatDateTime(this.startdate, this.starttime);

    let pla: ProfessionalLearningDTO;
    pla = new ProfessionalLearningDTO();
    pla.PLAId = this.pLAId;
    pla.ActivityDetails = this.activityAndPresenters;
    // pla.ImagePath = this.imagePath;
    pla.ImagePath = (this.imagePath == this.pLAList[index].ImagePath) ? this.imagePath.slice(this.imageUploadApiUrlLength) : this.imagePath;
    pla.EvidenceDescription = this.evidenceDescription;
    pla.Provider = this.providerDetails;
    pla.ReflectivePractice = this.reflectivePractice;
    pla.TopicDescription = this.topicsDescription;
    pla.CPD = this.cPDNumber;
    pla.StartDate = this.startdate;
    pla.StartTime = this.starttime;
    pla.Start = this.start;

    this.loading = true;

    this.scrubUpService.UpdatePLA(this.token, pla, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Update Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        });
        // this.specialityName = "";
        this.UserClick(3);
        this.getPLAList();
      }
      else {

      }
      this.loading = false;
    });
  }

  ngOnInit() {

    this.getPLAList();

  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/professional-training/professional-training.component.ts